import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "../components/LanguageSwitcher";

export default function LegalPage() {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const PATH_KEYS = {
    "aviso-legal": "avisoLegal",
    "politica-privacidad": "privacidad",
    "politica-cookies": "cookies",
    "condiciones": "condiciones"
  };

  const currentPathSegment = Object.keys(PATH_KEYS).find(key => location.pathname.includes(key));
  const content = currentPathSegment ? t(`legal.${PATH_KEYS[currentPathSegment]}`, { returnObjects: true }) : null;

  if (!content) {
    return (
      <div className="min-h-screen bg-[#FAFAF7] flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl text-[#0C2340] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
            {t("legal.notFound")}
          </h1>
          <Link to={`/${i18n.language}`} className="text-[#C8A24D] hover:underline font-medium">
            {t("legal.back")}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FAFAF7]">
      {/* Header */}
      <header className="bg-white border-b border-[#E8E4DC]/50 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to={`/${i18n.language}`} className="flex items-center gap-2 text-[#4A5568] hover:text-[#0C2340] transition-colors text-sm font-medium">
            <ArrowLeft className="w-4 h-4" />
            {t("legal.back")}
          </Link>
          <LanguageSwitcher />
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <h1 className="text-3xl sm:text-4xl text-[#0C2340] mb-10" style={{ fontFamily: "'DM Serif Display', serif" }}>
          {content.title}
        </h1>

        <div className="space-y-10">
          {content?.sections?.map((section, idx) => (
            <div key={idx}>
              <h2 className="text-xl text-[#0C2340] mb-3 font-semibold">
                {section.heading}
              </h2>
              <p className="text-[#4A5568] leading-relaxed whitespace-pre-line">
                {section.text}
              </p>
            </div>
          ))}
        </div>

        <p className="text-sm text-[#7A7A8A] mt-16 pt-8 border-t border-[#E8E4DC]">
          {t("legal.updated")}
        </p>
      </main>
    </div>
  );
}
